<template>
	<div class="user-wrapper">
		<div class="editpassword">
           <div class="headerlogo">
                   <img :src="userinfo.img"/>
				  
				</div>
				<div class="headername">{{userinfo.userName}}</div>
				 
			<div class="edituserinfopanel">
				<el-collapse-transition>
                 <div class="formedit" v-show="isuserinfoshow">
					 <form>
						 <ul>
							 <li>
								 <i><img src="../../../static/images/login/xueyuan.png"/></i>&nbsp;&nbsp;<span>学校：</span>{{userinfo.schoolName}}
							 </li>
							  <li>
								 <i><img src="../../../static/images/login/count.png"/></i>&nbsp;&nbsp;<span>账号：</span>{{userinfo.account}}
							 </li>
							  <li>
								 <i><img src="../../../static/images/login/xinming.png"/></i>&nbsp;&nbsp;<span>姓名：</span>{{userinfo.userName}}
							 </li>
							  <li>
								 <i><img src="../../../static/images/login/role.png"/></i>&nbsp;&nbsp;<span>角色：</span>{{userinfo.roleName}}
							 </li>
							   <li v-if="userinfo.headmaster" :title="userinfo.headmaster">
								 <i><img src="../../../static/images/login/role.png"/></i>&nbsp;&nbsp;<span>班级：</span>{{userinfo.headmaster}}
							 </li>
							  <li>
								 <i><img src="../../../static/images/login/mobile.png"/></i>&nbsp;<span>手机号码：</span>{{userinfo.mobile}}
							 </li>
							  <li style="border:none;">
								 <i><img src="../../../static/images/login/password.png"/></i>&nbsp;&nbsp;<span>密码：</span>******<el-button @click="editpassword" style="float:right;    margin-top: 5px;">修改</el-button>
							 </li>
						 </ul>
					 </form>
				 </div>
				 </el-collapse-transition>
				 <el-collapse-transition>
				 <div class="formedit idt" v-show="!isuserinfoshow">
					 <el-form :model="pwdForm" :rules="rules" ref="resetForm" >
						<el-row :gutter="20">
							 <el-col :span="24">
								 &nbsp;&nbsp;<span>修改密码</span>
							 </el-col>
							    <el-col :span="24">
								   <el-form-item prop="oldPWD" >
										<el-input type="password" v-model="pwdForm.oldPWD" placeholder="请输入账号原密码" auto-complete="off"></el-input>
								   </el-form-item>
						        </el-col>
							    <el-col :span="24">
					
									 <el-form-item prop="newPWD" >
										<el-input type="password" v-model="pwdForm.newPWD" placeholder="请输入新密码,6-20字,区分大小写,不允许空格" auto-complete="off"></el-input>
									</el-form-item>
					        	</el-col>
							    <el-col :span="24">
							 
									 <el-form-item prop="confirmPWD" >
											<el-input type="password" v-model="pwdForm.confirmPWD" placeholder="请再次输入新密码,6-20字,区分大小写,不允许空格" auto-complete="off"></el-input>
									 </el-form-item>
						        </el-col>
							    <el-col :span="24">
						    
								  <el-button @click="editpassword" style="float:right;    margin-top: 5px;">取消</el-button>
								 <el-button @click="submiteditpassword" style="float:right;    margin-top: 5px;">确定</el-button>
								</el-col>
					    </el-row>	
						
					 </el-form>
				 </div>
				</el-collapse-transition>
			</div>
		</div>
	</div>
</template>

<script>
	import Api from '@/api';
	import { session } from '@/util'
	export default {

		data() {
			let validatePass = (rule, value, callback) => {			
             let msg = '密码长度6~20位，只能由数字、字母和特殊字符组成';
            let regExp = /^([a-z0-9\.\,\。\{\}\[\]\|\:\;\'\"\<\>\?\/\\\-\+\@\!\#\$\%\^\&\*\(\)]){6,20}$/i;
            if (!regExp.test(value)) {
                callback(new Error(msg));
            }
            if (this.pwdForm.confirmPwd !== '') {
                this.$refs.resetForm.validateField('confirmPWD');
            }
            callback();
			};
			let validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.pwdForm.newPWD) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				isuserinfoshow:true,
				userinfo: {
				tsr:{}
				},
				 rules: {
                oldPWD: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
                newPWD: [{ required: true, validator: validatePass, trigger: 'blur' }],
                confirmPWD: [{ required: true, validator: validatePass2, trigger: 'blur' }]
            },
				
				pwdForm:{
					id:'',
					oldPWD:'',
					newPWD:'',
					confirmPWD:''

				}
			
			}
		},
		methods: {
		   submiteditpassword()
		   {
			   	this.$refs.resetForm.validate(valid => {
					   if(valid)
					   {

						   Api.systemConfig.updPWD(this.pwdForm).then(res=>{
								
								if(res.code==0)
								{
									this.openSuccessDialog("提示", "修改成功",()=>{this.logoutDirect()});
                                    
								}else
								{
                                    this.openSuccessDialog("提示", res.message);
								}
						   })
					   }
				   });
		   },
		   openSuccessDialog(title, msg, callback) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>${msg}!</p>
                        </div>`;


            this.$alert(html, title,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(()=>{
            	callback();
            })
		},
		logoutDirect() {
				Api.user.logout().then((res) => {
					let code = res.code;
					if(code === 0) {
						this.$router.replace({
							path: '/logining'
						});
					}
				});
				// this.$store.dispatch(LOGOUT)
				// this.$root.menuData = {};
				// this.$router.replace({ path: '/login' });
				//    location.reload()
			},
		   editpassword()
		   {
			   this.$refs["resetForm"].resetFields();
			   this.isuserinfoshow=!this.isuserinfoshow;			
			this.pwdForm={
					id:'',
					oldPWD:'',
					newPWD:'',
					confirmPWD:''

				}	;		
			this.pwdForm.id=this.userinfo.accountId;
			this.queryUserInfo();		
		   },
		   queryUserInfo()
		   {
					   let user=session('user');
					   let token = session('token');
					   let str='accountId='+user.accountId;
					   str+='&sysCode=suguan';
					   str+='&schoolId='+user.schoolId;
					   Api.systemConfig.queryUserInfo(str).then(res=>{
						
						 this.userinfo=res.data;				
						 if(this.userinfo.img) {
							this.userinfo.img = "/suguan/oss/i" + this.userinfo.img + '?token=' + token.accesstoken;
						}else
						{
							this.userinfo.img = "../../../static/images/login/logoheader.png" ;
						}
					   })
		   }
		},
		mounted() {		
			this.queryUserInfo();	
		}
	}
</script>

<style type="text/css" lang="scss" rel="stylesheet/scss">
.editpassword{
	width: 637px;
    height: 796px;
    margin: 50px auto;
    background: #F0F0F0 url(/static/images/login/editpasswordbg.png);
    background-size: cover;
    border: 1px solid #cccccc;
    position: relative;
    border-radius: 10px;
	.headerlogo{
		    width: 160px;
			height: 160px;
			border-radius: 160px;
			overflow: hidden;
			position: absolute;
			top: 25%;
			left: 50%;
			margin-top:-80px;
			margin-left:-80px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.headername
	{
		position: absolute;
    color: white;
    top: 38%;
    left: 50%;
    width: 160px;
    height: 40px;
    line-height: 40px;
    margin-top: -20px;
    margin-left: -80px;
    text-align: center;
	}
	.edituserinfopanel
	{
           width: 360px;
			height: 280px;
			position: absolute;
			bottom: 25%;
			left: 50%;
			margin-bottom:-140px;
			margin-left:-180px;
			background: white;
			.formedit
			{
				width: 100%;
				height: 100%;
				ul{
					li{
						font-size: 16px;
						 overflow:hidden;
						text-overflow:ellipsis;
						white-space:nowrap;
						font-family: "微软雅黑";
						list-style: none;
						width:100%;
						height: 43px;
						line-height: 43px;
						color: #333333;
						border-bottom: 1px dashed #bdbdbd;
						img{
							vertical-align: middle;
							margin-left: 20px;
						}
					}
				}
			}
			
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/user/forgetPwd.vue